<script setup lang="ts">
const { t } = useI18n({ useScope: 'local' })

definePageMeta({
  isPublic: true,
})

usePageTitle(computed(() => t('pageTitle')))
</script>

<template>
  <CardMedium class="mb-10 mt-4">
    <AuthLogin class="rounded-xl pb-4" />
  </CardMedium>
</template>

<i18n lang="json">
{
  "en": {
    "pageTitle": "Login"
  },
  "nl": {
    "pageTitle": "Inloggen"
  }
}
</i18n>
